<h2>Petitions</h2>

<app-loading-overlay [isLoading$]="isLoading$"></app-loading-overlay>

<mat-list class="petitions">
    <ng-container *ngFor="let category of categories">
        <app-category-subheader [category]="category"></app-category-subheader>
        <mat-list-item *ngFor="let petition of getPetitionsOfCategory(category)">
            <app-petition-summary [petition]="petition"></app-petition-summary>
        </mat-list-item>
    </ng-container>
    <app-category-subheader></app-category-subheader>
    <mat-list-item *ngFor="let petition of getPetitionsOfCategory(undefined)">
        <app-petition-summary [petition]="petition"></app-petition-summary>
    </mat-list-item>
</mat-list>
